import React, { useEffect, useState } from "react";
import { X, Coffee } from "lucide-react";
import Avatar from "./Avatar";

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Morning";
  if (h < 17) return "Afternoon";
  return "Evening";
}

// Shown once per login session, auto-hides after 8s.
export default function WelcomeBanner({ user }) {
  const key = user?.id ? `glcc_welcomed_${user.id}` : null;
  const [show, setShow] = useState(() => !!key && !sessionStorage.getItem(key));

  useEffect(() => {
    if (!show || !key) return;
    sessionStorage.setItem(key, "1");
    const t = setTimeout(() => setShow(false), 8000);
    return () => clearTimeout(t);
  }, [show, key]);

  if (!show) return null;
  const name = (user?.name || "").trim() || "rider";
  const first = name.split(/\s+/)[0];
  const bits = [user?.role, user?.member_no ? `Member #${user.member_no}` : null].filter(Boolean);
  const bought = user?.lifetime_rounds_bought || 0;
  return (
    <div
      className="mx-4 mt-3 mb-1 flex items-center gap-3 bg-accent-pink text-white rounded-2xl px-4 py-3 shadow-pink animate-slide-down"
      data-testid="welcome-banner"
    >
      <Avatar name={name} photo={user?.photo} size="md" className="ring-2 ring-white/70 !bg-white !text-accent-pink" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] font-mono-stat uppercase tracking-widest opacity-90">
          {greeting()}, {first} · {bits.join(" · ")}
        </div>
        <div className="font-heading font-black text-lg leading-tight truncate" data-testid="welcome-banner-text">
          Welcome back, {name}
        </div>
        <div className="text-[11px] opacity-90 flex items-center gap-1 truncate" data-testid="welcome-banner-sub">
          <Coffee className="w-3 h-3 shrink-0" />
          {user?.coffee ? `${user.coffee} is your usual` : "Set your usual coffee in your profile"}
          {bought > 0 ? ` · ${bought} round${bought === 1 ? "" : "s"} shouted` : ""}
        </div>
      </div>
      <button
        onClick={() => setShow(false)}
        className="p-1 rounded-full hover:bg-white/20 self-start"
        aria-label="Dismiss"
        data-testid="welcome-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
